import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hotelesOpciones, logos } from "../../../hook/Arreglos";
import { obtenerListaEmpresas } from "../../../store/Empresa/thunkEmpresa";
import { traerTodoslosClientesSegunlaempresa } from "../../../store/clientes/thunkClientes";
import { getCotizacion, traerSalones } from "../../../store/cotizaciones/thunkCotizaciones";
import { UnificarModales } from "../Modales/UnificarModales";
import { EjecutivoInfo } from "./VistasCotizacion/EjecutivoInfo";
import { ClienteInfo } from "./VistasCotizacion/ClienteInfo";
import { CotizacionInfo } from "./VistasCotizacion/CotizacionInfo";
import { CalendarioSeleccion } from "./VistasCotizacion/CalendarioSeleccion";
import { TablaRequerimientos } from "./VistasCotizacion/TablaRequerimientos";
import { ResumenTotalesRequerimientos } from "./VistasCotizacion/ResumenTotales";
import { TablaOtrosServicios } from "./VistasCotizacion/TablaOtrosServicios";
import { ResumenTotalesOtroServicios } from "./VistasCotizacion/ResumenTotalesOtroServicios";
import { TablaHabitaciones } from "./VistasCotizacion/TablaHabitaciones";
import { ResumenHabitaciones } from "./VistasCotizacion/ResumenHabitaciones";
import { TotalGlobal } from "./VistasCotizacion/TotalGlobal";
import { NotaCotizacion } from "./VistasCotizacion/NotaCotizacion";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { obtenerListaArticulosSegunGrupo } from "../../../store/Articulos/thunkArticulos";
import { PoliticasLargas } from "./PliticasEditables/PoliticasLargas";
import { crearContrato, editarContrato, extraerContratoId, obtenerNumeroConsecutivoContrato } from "../../../store/contratos/thunkContratos";
import { PoliticasCorta } from "./PliticasEditables/PoliticasCorta";

/**
 * Función para formatear una fecha a un formato legible en español.
 * Devuelve la fecha con detalles como día de la semana, mes, año, hora y minutos.
 */
const formatearFecha = (fecha) =>
    fecha
        ? new Date(fecha).toLocaleString("es-ES", {
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
              year: "numeric",
              month: "long",
              day: "numeric",
              weekday: "long",
          })
        : "N/D";

/**
 * Componente principal para la creación de cotizaciones.
 * Este componente gestiona el estado global de la cotización, las llamadas a la API y la lógica
 * para seleccionar empresas, clientes, fechas, hoteles y requerimientos.
 */
export const EditarContrato = () => {
    const navigate = useNavigate();
    // Hook de Redux para despachar acciones y obtener estado global.
    const dispatch = useDispatch();

    // Estado local para manejo de opciones y datos auxiliares
    const [empresasOpciones, setEmpresasOpciones] = useState([]);
    const [clientesOpciones, setClientesOpciones] = useState([]);
    const [todosLosclientes, setTodosLosclientes] = useState([]);
    const [preloadCliente, setPreloadCliente] = useState(false);
    const [mostrarCalendario, setMostrarCalendario] = useState(false);

    const [name_admin, setNameAdmin] = useState("");
    const [puesto, setPuesto] = useState("");
    const [email_admin, setEmailAdmin] = useState("");
    const [phone_admin, setPhoneAdmin] = useState("");

    // Estado principal del formulario que contiene toda la información necesaria para la cotización
    const [formulario, setFormulario] = useState({
        fechaCreacion: formatearFecha(new Date()),
        datosCliente: {},
        consecutivo: "",
        nombreEvento: "",
        idAdmin: "",
        MonedaTipo: [
            { id: 1, nombre: "$", estado: true },
            { id: 2, nombre: "¢", estado: false },
        ],
        hotelSeleccionado: "",
        empresaSeleccionada: "",
        fechaSeleccionadas: [],
        requerimientos: [],
        otroServicios: [],
        requerimientoshabitaciones: [],
        totalRequerimientos: {
            subtotal: 0,
            impuestoVenta: 0,
            impuestoServicio: 0,
            totalAB: 0,
        },
        totalOtroServicios: {
            subtotal: 0,
            impuestoVenta: 0,
            impuestoServicio: 0,
            totalAB: 0,
        },
        totalHabitaciones: {
            subtotal: 0,
            impuestoVenta: 0,
            impuestoServicio: 0,
            totalAB: 0,
        },
        totalGlobalCotizacion: 0,
        notaCoti: "",
        tokenEvento: "",

        celebro_contrato: "",
        cedula_contrato: "",
        empresaC_contrato: "",
        formapago_contrato: "",
        hotelC_contrato: "",
        garantia_contrato: "",
        dato1_contrato: "",
        dato2_contrato: "",
    });

    /**
     * Función para cambiar el símbolo de la moneda utilizada.
     * Alterna entre dólares y colones.
     */
    const cambiarSimbolo = () => {
        setFormulario((prev) => ({
            ...prev,
            MonedaTipo: prev.MonedaTipo.map((moneda) =>
                moneda.id === 2
                    ? {
                          ...moneda,
                          estado: !prev.MonedaTipo.find((m) => m.id === 2).estado,
                      }
                    : { ...moneda, estado: !moneda.estado },
            ),
        }));
    };

    /**
     * Obtiene el símbolo de la moneda activa (la que tenga estado: true).
     * Por defecto es "$" si no se encuentra otra activada.
     */
    const monedaActiva = formulario.MonedaTipo.find((moneda) => moneda.estado)?.nombre || "$";

    /**
     * Asigna el logo del hotel según el ID seleccionado.
     * Si no se encuentra coincidencia, se muestra un logo genérico.
     */
    const asignarLogo = (idHotel) => {
        const hotel = logos.find((item) => item.id === Number(idHotel));
        return hotel ? hotel.logo : "/assets/logo2.jpg";
    };

    /**
     * Obtiene la lista de empresas desde la API mediante un thunk y las
     * asigna a las opciones del select correspondiente.
     * También, por ejemplificación, establece un par de fechas preseleccionadas.
     */
    const fetchEmpresa = useCallback(async () => {
        try {
            const empresasData = await dispatch(obtenerListaEmpresas());
            const opcionesEmpresas = empresasData.map(({ id_empresa, nombre_empresa }) => ({
                value: id_empresa,
                label: nombre_empresa,
            }));
            setEmpresasOpciones(opcionesEmpresas);
        } catch (error) {
            console.error("Error al obtener empresas:", error);
        }
    }, [dispatch]);

    // Llama a fetchEmpresa al montar el componente para precargar las empresas.
    useEffect(() => {
        fetchEmpresa();
    }, [fetchEmpresa]);

    // Hook para extraer el parámetro "data" de la URL
    const getIdFromUrl = useCallback(() => {
        const params = new URLSearchParams(location.search);
        return params.get("data");
    }, [location.search]);

    /**
     * Obtiene la lista de salones para un hotel.
     */
    const fetchSalonesAPI = useCallback(
        async (hotelValue) => {
            const salones = await dispatch(traerSalones({ idHotel: hotelValue }));

            return salones.map((salon) => ({ value: salon.id_salon, label: salon.nombre_salon }));
        },
        [dispatch],
    );

    /**
     * Obtiene la lista completa de artículos.
     * Podrías adaptarlo para filtrar según el hotel, si fuese necesario.
     */
    const fetchArticulosAPI = useCallback(
        async (grupo) => {
            const articulos = await dispatch(obtenerListaArticulosSegunGrupo(1, grupo));
            return articulos.map((art) => ({
                value: art.id_articulo,
                label:
                    !art.hotelesSeleccionados || art.hotelesSeleccionados.length === 0 ? `Sin hotel / ${art.nombre_articulo}` : art.nombre_articulo,
            }));
        },
        [dispatch],
    );

    // Función para procesar los requerimientos, devolviendo un arreglo de promesas
    const procesarRequerimientos = async (requerimiento, grupo) => {
        return await Promise.all(
            requerimiento.map(async (req) => {
                // Procesar fechas: dividir por comas, eliminar espacios y filtrar valores no válidos
                const fechas = req.fecha_req_con
                    ? req.fecha_req_con
                          .split(",") // Dividir por comas
                          .map((f) => f.trim()) // Eliminar espacios alrededor de cada fecha
                          .filter((f) => f) // Filtrar fechas válidas (no vacías)
                    : []; // Si no hay fecha, usar un array vacío

                // Procesar salones: dividir por comas, eliminar espacios, convertir a números y filtrar valores no numéricos
                const salon = req.salones_req_con
                    ? req.salones_req_con
                          .split(",") // Dividir por comas
                          .map((s) => parseInt(s.trim(), 10)) // Convertir a números
                          .filter((s) => !isNaN(s)) // Filtrar valores no numéricos
                    : []; // Si no hay salones, usar un array vacío

                // Llamar a la API para obtener las opciones de artículos disponibles
                const newArticulosOptions = await fetchArticulosAPI(grupo);

                // Llamar a la API para obtener las opciones de salones disponibles
                const newSalonesOptions = await fetchSalonesAPI(req.hotelid_con ? req.hotelid_con : "200", grupo);

                // Devolver un objeto con los datos procesados del requerimiento
                return {
                    id: req.id_req_con, // ID del requerimiento
                    hotel: req.hotelid_con || "", // ID del hotel o vacío si no existe
                    hora: req.hora_req_con, // Hora del requerimiento
                    fecha: fechas, // Array de fechas procesadas
                    cantidad: parseInt(req.pax_req_con), // Cantidad de participantes
                    articulos: parseInt(req.articulo_req_con), // ID del artículo requerido
                    descripcionArticulo: req.dec_req_con.trim(), // Descripción del artículo, sin espacios extra
                    dias: parseInt(req.dias_req_con), // Número de días del requerimiento
                    salon: salon, // Array de IDs de salones procesados
                    precio: req.precio_req_con, // Precio del requerimiento
                    subtotal: req.subtotal_req_con, // Subtotal del requerimiento
                    salonOptions: newSalonesOptions, // Opciones de salones disponibles
                    articulosOptions: newArticulosOptions, // Opciones de artículos disponibles
                };
            }),
        );
    };

    // Función para procesar un conjunto de requerimientos de habitaciones
    const procesarHabitaciones = async (requerimiento, grupo) => {
        return await Promise.all(
            requerimiento.map(async (req) => {
                // Llama a una API externa para obtener las opciones de artículos disponibles basadas en el grupo
                const newArticulosOptions = await fetchArticulosAPI(grupo);

                // Procesa y devuelve un objeto con los datos estructurados de cada requerimiento
                return {
                    id: req.id_roomreq_con, // ID único del requerimiento de la habitación
                    fechaUno: req.fechin_roomreq_con, // Fecha de entrada de la habitación
                    fechaDos: req.fechout_roomreq_con, // Fecha de salida de la habitación
                    noches: req.noches_roomreq_con, // Número de noches de la estancia
                    descripcionArticulo: req.dec_roomreq_con, // Descripción del artículo solicitado
                    cantidadHabitaciones: req.cant_roomreq_con, // Cantidad de habitaciones solicitadas
                    precio: req.tarifa_roomreq_con, // Tarifa base de la habitación
                    subtotal: req.sub_roomreq_con, // Subtotal calculado para el requerimiento
                    articulosOptions: newArticulosOptions, // Opciones de artículos disponibles asociadas al grupo
                    hotel: req.hotelid_con, // ID del hotel asociado al requerimiento
                    tipoHabitacion: parseInt(req.tipo_roomreq_con), // Tipo de habitación como número entero
                };
            }),
        );
    };

    const extraerDatosEvento = useCallback(async () => {
        try {
            // Mostrar un modal de carga para indicar que se están obteniendo los datos
            Swal.fire({
                title: "Cargando...",
                text: "Espera mientras cargamos los datos",
                allowOutsideClick: false, // Bloquear la interacción externa mientras se carga
                didOpen: () => {
                    Swal.showLoading(); // Mostrar un spinner para feedback visual
                },
            });

            // Extraer el identificador desde la URL utilizando una función personalizada
            const ids = getIdFromUrl();

            // Validar si el identificador es válido
            if (!ids || ids === "0" || ids === 0) {
                Swal.close(); // Cerrar el modal si el ID no es válido
                return; // Detener la ejecución de la función
            }

            // Obtener los datos de cotización asociados al identificador desde el store
            const resul = await dispatch(extraerContratoId(ids));

            // Extraer los datos relevantes de la respuesta
            const resultado = resul.contrato.data[0];
            const requerimiento = resul.requerimientos.data || []; // Requerimientos asociados
            const otrosServ = resul.otrosServicios.data || []; // Otros servicios asociados
            const total_requerimientos = resul.totalRequerimientos.data["0"] || []; // Totales de requerimientos
            const habit = resul.habitaciones.data || []; // Requerimientos de habitaciones

            // Determinar el tipo de moneda basado en la respuesta
            const monedaSeleccionada = resultado.moneda_contrato === 0 ? { id: 1, nombre: "$", estado: true } : { id: 2, nombre: "¢", estado: true };

            // Procesar los requerimientos de la cotización, si existen
            const requerimientosResult = requerimiento.length > 0 ? await procesarRequerimientos(requerimiento, "AYB") : [];

            // Procesar los otros servicios de la cotización, si existen
            const OtroServiciosResult = otrosServ.length > 0 ? await procesarRequerimientos(otrosServ, "otros") : [];

            const ResultHabitaciones = habit.length > 0 ? await procesarHabitaciones(habit, "Rooms") : [];


            // Actualizar el estado del formulario con los datos obtenidos
            setFormulario((prev) => ({
                ...prev,
                hotelSeleccionado: resultado.id_hotel_contrato, // ID del hotel asociado
                consecutivo: resultado.id_consecutivo_contrato, // Número de consecutivo
                fechaCreacion: formatearFecha(resultado.fecha_creacion_contrato), // Fecha de creación formateada
                fechaSeleccionadas:
                    resultado.fecha_evento_contrato && resultado.fecha_evento_contrato !== "Fecha por definir"
                        ? resultado.fecha_evento_contrato.split(",").map((f) => new Date(`${f.trim()}T00:00:00`))
                        : [], // Convertir fechas de string a objeto Date
                nombreEvento: resultado.nombre_evento_contrato, // Nombre del evento
                nombreEjecutivo: resultado.name_admin || "Sin definir", // Nombre del ejecutivo responsable
                cargoEjecutivo: resultado.puesto || "Sin definir", // Cargo del ejecutivo
                correoEjecutivo: resultado.email_admin || "Sin definir", // Correo del ejecutivo
                telefonoEjecutivo: resultado.phone_admin || "Sin definir", // Teléfono del ejecutivo
                empresaSeleccionada: resultado.idEmpresaRelacion, // ID de la empresa asociada
                tokenEvento: resultado.ReferenciaEvento, // Token único del evento
                MonedaTipo: prev.MonedaTipo.map((moneda) =>
                    moneda.id === monedaSeleccionada.id ? { ...moneda, estado: true } : { ...moneda, estado: false },
                ), // Actualizar el estado de la moneda
                notaCoti: resultado.nota_contrato || "", // Notas de la cotización
                requerimientos: requerimientosResult, // Lista procesada de requerimientos
                otroServicios: OtroServiciosResult, // Lista procesada de otros servicios
                totalRequerimientos: {
                    subtotal: total_requerimientos.subtReq_Subt_con,
                    impuestoVenta: total_requerimientos.treceReq_Subt_con,
                    impuestoServicio: total_requerimientos.diezReq_Subt_con,
                    totalAB: total_requerimientos.totalReq_Subt_con,
                },
                totalOtroServicios: {
                    subtotal: total_requerimientos.subtOtro_Subt_con,
                    impuestoVenta: total_requerimientos.treceOtro_Subt_con,
                    impuestoServicio: 0,
                    totalAB: total_requerimientos.totalOtro_Subt_con,
                },
                totalHabitaciones: {
                    subtotal: total_requerimientos.subtsubtRoom_Subt_con,
                    impuestoVenta: total_requerimientos.trecesubtRoom_Subt_con,
                    impuestoServicio: total_requerimientos.mucamasubtRoom_Subt_con,
                    totalAB: total_requerimientos.totalsubtRoom_Subt_con,
                },
                requerimientoshabitaciones: ResultHabitaciones,
                idAdmin: resultado.admin_contrato,

                celebro_contrato: resultado.celebro_contrato,
                cedula_contrato: resultado.cedula_contrato,
                empresaC_contrato: resultado.empresaC_contrato,
                hotelC_contrato: resultado.hotelC_contrato,
                formapago_contrato: resultado.formapago_contrato,
                admin_fecha: "",
                admin_name: resultado.name_admin,
                admin_hotel: resultado.hotelC_contrato,
                garantia_contrato: resultado.garantia_contrato,
                dato1_contrato: resultado.dato1_contrato,
                dato2_contrato: resultado.dato2_contrato,
            }));

            // Actualizar estados específicos con datos del ejecutivo
            setNameAdmin(resultado.name_admin);
            setPuesto(resultado.puesto);
            setEmailAdmin(resultado.email_admin);
            setPhoneAdmin(resultado.phone_admin);

            // Ejecutar lógica adicional basada en la empresa seleccionada
            await ejecutarFuncionAdicional(resultado.idEmpresaRelacion);

            // Extraer y actualizar el ID del cliente relacionado con la cotización
            const idClienteEvento = resultado.cliente_contrato;
            setFormulario((prev) => ({
                ...prev,
                clienteSeleccionado: idClienteEvento, // ID del cliente seleccionado
            }));

            // Cerrar el modal de carga tras finalizar el proceso
            Swal.close();
        } catch (error) {
            // Manejar cualquier error ocurrido durante el proceso
            console.error("Error al obtener los datos del evento:", error);
        }
    }, [dispatch, getIdFromUrl]);

    // Ejecutar la extracción de datos del evento cuando existan opciones de empresas
    useEffect(() => {
        if (empresasOpciones.length > 0) {
            extraerDatosEvento();
        }
    }, [empresasOpciones, extraerDatosEvento]);

    useEffect(() => {
        if (clientesOpciones.length > 0) {
            seleccionarCliente(formulario.clienteSeleccionado);
        }
    }, [clientesOpciones]);

    /**
     * Dada la empresa seleccionada, carga todos los clientes asociados a esa empresa
     * y actualiza las opciones del select de clientes.
     *
     * @param {string} selected - El identificador de la empresa seleccionada.
     */
    const ejecutarFuncionAdicional = async (selected) => {
        try {
            // Reinicia los datos del cliente en el formulario seleccionando una nueva empresa.
            setFormulario((prev) => ({ ...prev, datosCliente: "" }));

            // Activa el estado de preloader para indicar que se está cargando la información de clientes.
            setPreloadCliente(true);

            // Despacha una acción para traer todos los clientes asociados a la empresa seleccionada.
            // `traerTodoslosClientesSegunlaempresa` es una acción asíncrona que probablemente hace una llamada al backend.
            const leadData = await dispatch(traerTodoslosClientesSegunlaempresa(selected));

            // Mapea los datos de los clientes recibidos para Editar las opciones del select de clientes.
            // Cada opción tiene un valor (`value`) que corresponde al ID del cliente y una etiqueta (`label`) que muestra el nombre del cliente.
            const options = leadData.map(({ id_cliente, nombre_cliente }) => ({
                value: id_cliente,
                label: nombre_cliente,
            }));

            // Actualiza el estado de las opciones de clientes para que el componente select las muestre.
            setClientesOpciones(options);

            // Guarda todos los clientes obtenidos en el estado `todosLosclientes` para usos futuros o referencias.
            setTodosLosclientes(leadData);

            // Desactiva el estado de preloader una vez que la carga de clientes ha finalizado.
            setPreloadCliente(false);
        } catch (error) {
            // Registra el error en la consola para propósitos de diagnóstico.
            console.error("Error al cargar los clientes:", error);

            // Opcional: Puedes agregar una notificación al usuario informando sobre el error.
            // Por ejemplo, usando Swal:
            // Swal.fire({
            //     title: "Error",
            //     text: "No se pudieron cargar los clientes. Por favor, inténtelo nuevamente.",
            //     icon: "error",
            // });

            // Asegura que el preloader se desactive incluso si ocurre un error.
            setPreloadCliente(false);
        }
    };

    /**
     * Asigna el cliente seleccionado al formulario.
     * Esto permite mostrar la información del cliente (correo, teléfono, etc.).
     */
    const seleccionarCliente = async (selected) => {
        if (!selected) return;
        const clienteSeleccionado = todosLosclientes.find((cli) => cli.id_cliente === Number(selected));

        if (clienteSeleccionado) {
            setFormulario((prev) => ({
                ...prev,
                datosCliente: clienteSeleccionado,
            }));
        }
    };

    /**
     * Maneja la selección de fechas desde el componente de calendario.
     * Almacena las fechas seleccionadas en el estado del formulario.
     */
    const handleSelect = (selectedDays) => {
        setFormulario((prev) => ({
            ...prev,
            fechaSeleccionadas: selectedDays || [],
        }));
    };

    /**
     * Elimina una fecha específica del arreglo de fechas seleccionadas.
     */
    const eliminarFecha = (fecha) => {
        setFormulario((prev) => ({
            ...prev,
            fechaSeleccionadas: prev.fechaSeleccionadas.filter((d) => d.getTime() !== fecha.getTime()),
        }));
    };

    /**
     * Maneja el envío del formulario para Editar una Contrato.
     * Realiza validaciones, muestra mensajes de alerta y gestiona la creación de la cotización.
     * @param {Event} e - Evento de envío del formulario.
     */
    const handleSubmit = (e) => {
        e.preventDefault(); // Evita que el formulario realice su acción por defecto al enviarse.

        // Validación: Verifica que se haya seleccionado un hotel.
        if (formulario.hotelSeleccionado === "") {
            Swal.fire({
                title: "Error",
                text: "Seleccione un hotel para continuar.",
                icon: "error",
            });
            return; // Detiene la ejecución si no se cumple la validación.
        }

        if (formulario.nombreEvento === "") {
            Swal.fire({
                title: "Error",
                text: "Nombre del evento es requerido.",
                icon: "error",
            });
            return; // Detiene la ejecución si no se cumple la validación.
        }

        // Validación: Verifica que se hayan ingresado los datos del cliente.
        if (Object.keys(formulario.datosCliente).length === 0) {
            Swal.fire({
                title: "Error",
                text: "Seleccione un cliente para continuar.",
                icon: "error",
            });
            return; // Detiene la ejecución si no se cumple la validación.
        }

        // Mostrar mensaje de confirmación al usuario antes de proceder con la creación.
        Swal.fire({
            title: "¿Estás seguro?",
            text: "Por favor, verifica bien los datos antes de Editar el Contrato.",
            icon: "warning",
            showCancelButton: true, // Muestra el botón de cancelación.
            confirmButtonText: "Sí, Editar", // Texto del botón de confirmación.
            cancelButtonText: "Cancelar", // Texto del botón de cancelación.
        }).then(async (result) => {
            // Verifica si el usuario confirmó la acción.
            if (result.isConfirmed) {
                // Muestra un mensaje con un preloader indicando que el proceso está en curso.
                Swal.fire({
                    title: "Editando Contrato...",
                    text: "Por favor, espere mientras termina el proceso.",
                    icon: "info",
                    allowOutsideClick: false, // Evita que el usuario cierre el modal haciendo clic afuera.
                    allowEscapeKey: false, // Evita que el usuario cierre el modal usando la tecla Escape.
                    didOpen: () => {
                        Swal.showLoading(); // Muestra una animación de carga.
                    },
                });

                try {
                    // Formatea las fechas seleccionadas en el formulario.
                    const fechasFormateadas = formulario.fechaSeleccionadas
                        .sort((a, b) => a - b) // Ordena las fechas de manera cronológica.
                        .map((fecha) => {
                            // Convierte cada fecha al formato 'YYYY-MM-DD'.
                            const year = fecha.getFullYear();
                            const month = String(fecha.getMonth() + 1).padStart(2, "0"); // Mes con dos dígitos.
                            const day = String(fecha.getDate()).padStart(2, "0"); // Día con dos dígitos.
                            return `${year}-${month}-${day}`;
                        });

                    const ids = getIdFromUrl();
                    // Despacha la acción para crear la cotización y espera su finalización.
                    // `crearCotizacion` es una acción asíncrona que envía los datos al backend.
                    const result = await dispatch(editarContrato(formulario, fechasFormateadas, mostrarCalendario, formulario.idAdmin, ids));

                    // Verifica si la creación de la cotización fue exitosa mediante el ID retornado.
                    if (result.data.cotizacionId <= 0) {
                        Swal.fire({
                            title: "Error",
                            text: "Ocurrió un problema al editar Contrato. Inténtelo nuevamente.",
                            icon: "error",
                        });
                        return; // Detiene la ejecución si hubo un error en la creación.
                    }

                    // Muestra un mensaje de éxito indicando que la cotización se creó correctamente.
                    Swal.fire({
                        title: "Contrato Editado!",
                        text: "El Contrato ha sido editado con éxito.",
                        icon: "success",
                        timer: 4000, // Cierra el mensaje automáticamente después de 4 segundos.
                        showConfirmButton: false, // Oculta el botón de confirmación.
                    }).then(() => {
                        navigate(`/contratos/ver?data=${result.data.cotizacionId}`); // Redirige a la página de creación
                    });
                } catch (error) {
                    // Registra el error en la consola para diagnóstico.
                    console.error("Error al editar la Contrato:", error);

                    // Muestra un mensaje de error al usuario indicando que algo salió mal.
                    Swal.fire({
                        title: "Error",
                        text: "Ocurrió un problema al editar la Contrato. Inténtelo nuevamente.",
                        icon: "error",
                    });
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Si el usuario cancela la acción, muestra un mensaje indicando que no se creó la Contrato.
                Swal.fire("Cancelado", "No se creó la Contrato.", "error");
            }
        });
    };

    // Estado para controlar la visualización de las políticas
    const [mostrarPoliticasCortas, setMostrarPoliticasCortas] = useState(false);

    // Función para manejar el cambio del checkbox
    const manejarCambioPoliticas = (e) => {
        setMostrarPoliticasCortas(e.target.checked);
    };
    return (
        <>
            <div className="alert alert-success d-block text-center text-uppercase">
                <i className="feather icon-check-circle me-2"></i>Usted esta en Editar Contrato
            </div>
            <div role="alert" className="fade alert alert-warning show">
                Recuerda que en esta vista estas editando un contrato existente.
            </div>
            {/* Componente para manejar el cambio de moneda y mostrar la moneda activa */}
            <div className="mb-3">
                <div className="form-check form-switch">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        onChange={cambiarSimbolo}
                        checked={formulario.MonedaTipo.find((m) => m.id === 2)?.estado}
                        style={{ transform: "scale(1.5)" }}
                    />
                    <label className="form-check-label ms-2" style={{ fontSize: "1.2rem" }}>
                        Transformar a {monedaActiva === "¢" ? "dólares" : "colones"}
                    </label>
                </div>
                <h4>Símbolo de moneda actual:</h4>
                <h3>{monedaActiva}</h3>
            </div>

            <div className="d-flex align-items-center justify-content-between py-3 card-header">
                {/* Botón que abre un modal para acciones adicionales, integrándose con la lógica de fetchEmpresa */}
                <h5 className="mb-0"></h5>
                <button className="btn btn-sm btn-link-dark">
                    <UnificarModales functions={fetchEmpresa} />
                </button>
            </div>

            <div className="g-3 row">
                {/* Encabezado con el logo del hotel y el consecutivo */}
                <div className="col-12">
                    <div className="align-items-center g-3 row">
                        <div className="col-sm-6">
                            <div className="d-flex align-items-center mb-2">
                                <img
                                    alt="images"
                                    loading="lazy"
                                    width="160"
                                    height="28"
                                    decoding="async"
                                    className="img-fluid"
                                    src={asignarLogo(formulario.hotelSeleccionado)}
                                />
                            </div>
                            <h2 className="mb-0">#{formulario.consecutivo}</h2>
                        </div>
                    </div>

                    <br />
                    <br />
                    <TotalGlobal formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
                    {/* Selector de hotel */}
                    <div className="col-xl-3 col-sm-6">
                        <label className="form-label">Seleccione el hotel *</label>
                        <select
                            className="form-control"
                            value={formulario.hotelSeleccionado}
                            onChange={(e) =>
                                setFormulario((prev) => ({
                                    ...prev,
                                    hotelSeleccionado: e.target.value,
                                }))
                            }
                        >
                            <option value="">Seleccione el Hotel</option>
                            {hotelesOpciones.map((h) => (
                                <option key={h.value} value={h.value}>
                                    {h.label}
                                </option>
                            ))}
                            <option value="200">Todos los hoteles</option>
                        </select>
                    </div>
                </div>
                <div style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }} className="alert alert-secondary" role="alert">
                    INFORMACIÓN DE LA COTIZACIÓN
                </div>

                {/* Información del Ejecutivo (nombre, puesto, email, teléfono) */}
                <div className="col-sm-4">
                    <EjecutivoInfo name_admin={name_admin} puesto={puesto} email_admin={email_admin} phone_admin={phone_admin} />
                </div>

                {/* Información del Cliente (selección de empresa, cliente, correo, teléfono) */}
                <div className="col-sm-4">
                    <ClienteInfo
                        empresasOpciones={empresasOpciones}
                        clientesOpciones={clientesOpciones}
                        empresaSeleccionada={formulario.empresaSeleccionada}
                        clienteSeleccionado={formulario.clienteSeleccionado}
                        formulario={formulario}
                        preloadCliente={preloadCliente}
                        ejecutarFuncionAdicional={ejecutarFuncionAdicional}
                        seleccionarCliente={seleccionarCliente}
                        setFormulario={setFormulario}
                    />
                </div>

                {/* Información de la Cotización (fecha, nombre del evento y toggle del calendario) */}
                <div className="col-sm-4">
                    <CotizacionInfo
                        formulario={formulario}
                        setFormulario={setFormulario}
                        fechaCreacion={formulario.fechaCreacion}
                        setMostrarCalendario={setMostrarCalendario}
                    />
                </div>

                {/* Selección de Fechas mediante el Calendario */}
                <div className="col-sm-12">
                    <CalendarioSeleccion
                        mostrarCalendario={mostrarCalendario}
                        fechaSeleccionadas={formulario.fechaSeleccionadas}
                        handleSelect={handleSelect}
                        eliminarFecha={eliminarFecha}
                    />
                </div>

                {/* Tabla de Requerimientos asociados a la cotización (servicios, productos, cantidades, etc.) */}
                <TablaRequerimientos formulario={formulario} setFormulario={setFormulario} hotelesOpciones={hotelesOpciones} />
                {/* Resumen de Totales de la Cotización (subtotales, descuentos, impuestos y total) */}
                <div className="col-12">
                    <ResumenTotalesRequerimientos formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
                </div>
                <TablaOtrosServicios formulario={formulario} setFormulario={setFormulario} hotelesOpciones={hotelesOpciones} />
                <div className="col-12">
                    <ResumenTotalesOtroServicios formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
                </div>
                <TablaHabitaciones formulario={formulario} setFormulario={setFormulario} hotelesOpciones={hotelesOpciones} />
                <div className="col-12">
                    <ResumenHabitaciones formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
                </div>
                <div className="col-12">
                    <div style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }} className="alert alert-secondary" role="alert">
                        INGRESE LA NOTA PARA ESTA COTIZACIÓN
                    </div>
                    <NotaCotizacion formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
                </div>
                <div className="col-12">
                    <div style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }} className="alert alert-secondary" role="alert">
                        TOTALES GENERAL
                    </div>
                    <TotalGlobal formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
                </div>
            </div>
            <br />
            <br />
            <div className="col-12">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="mostrarPoliticas"
                        checked={mostrarPoliticasCortas}
                        onChange={manejarCambioPoliticas}
                    />
                    <label className="form-check-label" htmlFor="mostrarPoliticas">
                        Mostrar Políticas habitaciones
                    </label>
                </div>
            </div>

            <br />
            <br />

            {mostrarPoliticasCortas ? (
                <PoliticasCorta formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
            ) : (
                <PoliticasLargas formulario={formulario} setFormulario={setFormulario} monedaActiva={monedaActiva} />
            )}

            <br />

            {/* Botón para Editar la cotización, al hacer submit del formulario */}
            <div className="d-print-none align-items-center justify-content-end row">
                <div className="col-auto btn-page col">
                    <button type="buttom" className="btn-print-invoice btn btn-danger" id="btn-crear-cotizacion" onClick={handleSubmit}>
                        Editar Contrato
                    </button>
                </div>
            </div>
        </>
    );
};
